module.exports = __webpack_public_path__ + "media/images/pc/specials/fair_event/area_tvb-1e7eeee7a2d72c92de2622d38d6766ee.jpg";